import { render, staticRenderFns } from "./SettingVam.vue?vue&type=template&id=c0ce3ed6&scoped=true&"
import script from "./SettingVam.vue?vue&type=script&lang=js&"
export * from "./SettingVam.vue?vue&type=script&lang=js&"
import style0 from "./SettingVam.vue?vue&type=style&index=0&id=c0ce3ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ce3ed6",
  null
  
)

export default component.exports